import gsap from "gsap";
import { horizontalLoop, debounce } from "./utils";
const historySliderSections = document.querySelectorAll( ".company-history" );
historySliderSections.forEach( ( section, i ) => {
  const sliderDiv = section.querySelector( ".slider" );
  const slides = section.querySelectorAll( ".slider > div" );
  const controlsContainer = section.querySelector( ".slider-controls" );
  const historyWave = section.querySelector( "#history-wave" );

  let slideIndex = 0;
  let slideWidth;
  let gutter;
  let sliderParentOffsetLeft = sliderDiv.parentNode.getBoundingClientRect().left;
  let viewPortWidth = document.documentElement.clientWidth;
  let ellipseRX = 11.5,
    ellipseRY = 25,
    ellipseSpacing = 1.5,
    ellipses = [],
    activeEllipses = [],
    activeEllipseIndexes = [],
    activeEllipseProperties = [
      { cy: 309.129, ry: 29 },
      { cy: 309.129, ry: 29 },
      { cy: 305.629, ry: 32.5 },
      { cy: 296.129, ry: 42 },
      { cy: 283.629, ry: 54.5 },
      { cy: 269.629, ry: 68.5 },
      { cy: 252.629, ry: 85.5 },
      { cy: 238.129, ry: 100 },
      { cy: 218.629, ry: 119.5 },
      { cy: 194.629, ry: 143.5 },
      { cy: 169.129, ry: 169 },
      { cy: 194.629, ry: 143.5 },
      { cy: 218.629, ry: 119.5 },
      { cy: 238.129, ry: 100 },
      { cy: 252.629, ry: 85.5 },
      { cy: 269.629, ry: 68.5 },
      { cy: 283.629, ry: 54.5 },
      { cy: 296.129, ry: 42 },
      { cy: 305.629, ry: 32.5 },
      { cy: 309.129, ry: 29 },
      { cy: 309.129, ry: 29 },
    ];

  function updateSlideWidth () {
    viewPortWidth = document.documentElement.clientWidth;
    const closestRelative = sliderDiv.closest('.relative');
    const containerWidth = closestRelative.offsetWidth;
    const isDesktop = viewPortWidth >= 1024;
    
    gutter = isDesktop ? 40 : 32;   
    
    
    if(viewPortWidth >= 1024) {
      slideWidth = 582;
    } else {
      slideWidth = containerWidth - 16 -( gutter ) ;
    }
    slides.forEach(slide => {
      slide.querySelector('.slide-inner').style.width = slideWidth + "px";
    });

           // gutter depends on screen
    // if(viewPortWidth >= 1024) {
    //   slideWidth = 582;
    // } else if(viewPortWidth >= 600) {
    //   slideWidth = viewPortWidth * 0.8; // slide width minus left/right gutters
    // } else {
    //   slideWidth = viewPortWidth - gutter * 2;
    // }
    //slideWidth = isDesktop ? 582 : viewPortWidth - gutter * 2; // slide width minus left/right gutters
    console.log( "slideWidth:", slideWidth, "viewportWidth:", viewPortWidth, "gutter:", gutter );
  }


  function setSVGDimensions () {
    // console.log("setting svg dimensions");
    let svgWidth = Math.ceil( viewPortWidth / 13 ) * 13;
    svgWidth += ( slideWidth + gutter ) * ( slides.length - 1 );
    historyWave.setAttribute( "width", svgWidth );
    historyWave.setAttribute( "viewBox", `0 0 ${ svgWidth } 339` );
  }

  function destroyEllipses () {
    // console.log("destroying ellipses");
    historyWave.querySelectorAll( "ellipse" ).forEach( ( ellipse ) => {
      ellipse.remove();
    } );
  }

  function makeEllipses () {
    // console.log("making ellipses");
    ( ellipses = [] ), ( activeEllipses = [] ), ( activeEllipseIndexes = [] );
    for (
      let i = 0;
      i < viewPortWidth + ( slideWidth + gutter ) * ( slides.length - 1 );
      i += ellipseRX * 2 + ellipseSpacing
    ) {
      const ellipseElement = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "ellipse"
      );
      ellipseElement.setAttribute( "cx", i );
      ellipseElement.setAttribute( "cy", 313.129 );
      ellipseElement.setAttribute( "rx", ellipseRX );
      ellipseElement.setAttribute( "ry", ellipseRY );
      ellipseElement.setAttribute( "fill", "url(#ellipse-gradient)" );

      ellipses.push( ellipseElement );
      historyWave.appendChild( ellipseElement );
    }
  }
  function deactivateEllipses () {
    ellipses.forEach( ( ellipse ) => {
      gsap.to( ellipse, {
        attr: {
          cy: 313.129,
          ry: 25,
          rx: 11.5,
        },
        duration: 0.25,
      } );
    } );
  }
  function activateEllipses () {
    activeEllipses = [];
    activeEllipseIndexes = [];
    let magicNumber = viewPortWidth >= 1024 ? 24 : 80;
    if(viewPortWidth <= 500) {
      magicNumber = 0;
    }
    const amount =
      slideIndex * ( slideWidth + gutter ) + sliderParentOffsetLeft + magicNumber;

    ellipses.forEach( ( ellipse, i ) => {
      const cx = ellipse.getAttribute( "cx" );
      //   gsap.to(ellipse, {
      //     attr: {
      //       cy: 313.129,
      //       ry: 25,
      //       rx: 11.5,
      //     },
      //     duration: 0.5,
      //   });
      if ( cx >= amount && cx <= amount + slideWidth ) {
        activeEllipses.push( { index: i, ellipse: ellipse } );
        activeEllipseIndexes.push( i );
      } else {
        gsap.to( ellipse, {
          attr: {
            cy: 313.129,
            ry: 25,
            rx: 11.5,
          },
          duration: 0.25,
        } );
      }
    } );

    // all of the active ellipses
    activeEllipseIndexes.forEach( ( num, i ) => {
      if ( i < activeEllipseProperties.length ) {
        // console.log(activeEllipseProperties[i]);
        gsap.to( ellipses[ num ], {
          attr: {
            cy: activeEllipseProperties[ i ].cy,
            ry: activeEllipseProperties[ i ].ry,
            rx: 11.5,
          },
          duration: 0.5,
        } );
      }
    } );
    // one weird one

    // console.log(activeEllipseIndexes);
  }

  function updateSliderMetrics () {
    updateSlideWidth();
    sliderParentOffsetLeft = sliderDiv.parentNode.getBoundingClientRect().left;
  }

  function moveSlider () {
    deactivateEllipses();
    console.log('translating slider', -slideIndex * ( slideWidth + gutter ));
    sliderDiv.style.transform = `translateX(${ -slideIndex * ( slideWidth + gutter ) }px)`;
    historyWave.parentNode.style.transform = `translateX(${ -slideIndex * ( slideWidth + gutter ) }px)`;
    activateEllipses();
  }

  function nextSlide () {
    slideIndex++;
    if ( slideIndex >= slides.length ) slideIndex = 0;
    updateSliderMetrics();
    moveSlider();
    disableButtons();
  }

  function prevSlide () {
    if ( slideIndex <= 0 ) return;
    slideIndex--;
    updateSliderMetrics();
    moveSlider();
    disableButtons();
  }

  function disableButtons () {
    if ( slideIndex <= 0 ) {
      controlsContainer.querySelector( ".prev" ).disabled = true;
    } else {
      controlsContainer.querySelector( ".prev" ).disabled = false;
    }
    if ( slideIndex >= slides.length - 1 ) {
      controlsContainer.querySelector( ".next" ).disabled = true;
    } else {
      controlsContainer.querySelector( ".next" ).disabled = false;
    }
  }
  controlsContainer.querySelector( ".next" ).addEventListener( "click", nextSlide );
  controlsContainer.querySelector( ".prev" ).addEventListener( "click", prevSlide );
  updateSliderMetrics();
  updateSlideWidth();
  setSVGDimensions();
  makeEllipses();
  activateEllipses();

  window.addEventListener( "resize", function () {
    destroyEllipses();
  } );

  //debounced resize
  window.addEventListener(
    "resize",
    debounce( () => {
      updateSlideWidth();
      destroyEllipses();
      // console.log("resizing");
      viewPortWidth = window.innerWidth;

      sliderParentOffsetLeft =
        sliderDiv.parentNode.getBoundingClientRect().left;
      setSVGDimensions();
      //   destroyEllipses();
      makeEllipses();
      activateEllipses();
      slideIndex = 0;
      moveSlider();
      disableButtons();
    }, 100 )
  );
} );
